'use strict';

const i18n = require('i18next');
const Snackbar = require('common/util/snackbar');
const TaskAPI = require('communication/infra/api/task/index');
const TaskRepository = require('communication/domain/repository/task');
const TaskFactory = require('communication/domain/factory/task');

class Service {
    constructor(project, taskId, json) {
        this._project = project;
        this._taskId = taskId;
        this._json = json;
    }

    update() {
        return new Promise((resolve, reject) => {
            TaskAPI.update(this._project.id, this._taskId, this._json)
                .then(taskJSON => {
                    return new TaskFactory(this._project).build(taskJSON);
                })
                .then(task => {
                    TaskRepository.find(this._project).add(task);

                    Snackbar.success(
                        i18n.t('communication:feedback.task-update', {
                            name: task.getName()
                        })
                    );

                    resolve(task);
                });
        });
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./communication/app/service/task/update.js